import { useFeatureInteractionContext } from 'features/siteMap/contexts/FeatureInteractionContext'
import React, { FC } from 'react'
import styled from 'styled-components'

const ConfirmButtonDiv = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  font-family: sans-serif;
  width: fit-content;
  padding: 4px 8px;
  opacity: 0.8;
  margin: 16px auto 0;

  &:hover {
    opacity: 1;
    background-color: ${({ theme }) => theme.forecast.hoverButton};
  }
`

export const ConfirmButton: FC = () => {
  const { setShowFeaturePopupMenu } = useFeatureInteractionContext()

  return (
    <ConfirmButtonDiv onClick={() => setShowFeaturePopupMenu(undefined)}>
      Confirm
    </ConfirmButtonDiv>
  )
}
